import React, { useEffect } from 'react';
import { Button, Col, Container, Image, Row } from 'react-bootstrap';
import {getCurrentUser, signInWithRedirect} from 'aws-amplify/auth';
import foedusLogo from '../images/logo.svg';
import awsLogo from '../images/aws_logo.svg';
let foedusLogoImg = foedusLogo;
if (foedusLogo && foedusLogo?.search('{contextName}') !== -1) {
	foedusLogoImg = foedusLogo.replace('{contextName}', globalParams.contextName + '/');
}

const LOGIN_FLAG = 'cognitoLoginInProgress';
const CALLBACK_URL = '/simplifyworks/publics/cognito/callback';

const handleFederatedSignIn = async () => {
	try {
		localStorage.setItem(LOGIN_FLAG, 'true');
		await signInWithRedirect();
	} catch (err) {
		console.warn(err);
		if (err?.name === 'UserAlreadyAuthenticatedException') {
			window.location.replace(CALLBACK_URL);
		} else {
			console.error('signInWithRedirect error: ', err);
			localStorage.removeItem(LOGIN_FLAG);
		}
	}
};

export default function AmplifyAuthScreen() {
	useEffect(() => {
		localStorage.setItem('urlToRedirect', window.location.href);

		(async () => {
			const loginInProgress = localStorage.getItem(LOGIN_FLAG) === 'true';
			if (!loginInProgress) {
				return;
			}

			try {
				await getCurrentUser();
				window.location.replace(CALLBACK_URL);
			} catch (e) {
				localStorage.removeItem(LOGIN_FLAG);
			}
		})();
	}, []);

	return (
		<Container fluid className="vh-100 d-flex justify-content-center align-items-center">
			<Row className="w-100 justify-content-center">
				<Col xs="auto" className="text-center">
					<div className="mb-4 d-flex justify-content-center">
						<Image src={foedusLogoImg} alt="App Logo" width={240} />
					</div>
					<Button
						variant="primary"
						size="lg"
						onClick={handleFederatedSignIn}
						className="px-4 py-2"
						style={{ display: 'inline-flex', alignItems: 'center', gap: '10px' }}
					>
						<span style={{ fontSize: '1.1rem' }}>Sign in with</span>
						<Image
							src={awsLogo}
							alt="AWS Logo"
							width={28}
							height={28}
							style={{ display: 'inline-block' }}
						/>
					</Button>
				</Col>
			</Row>
		</Container>
	);
}
